import { render } from "./SubtaskEditView.vue?vue&type=template&id=e5d3786a"
import script from "./SubtaskEditView.vue?vue&type=script&lang=js"
export * from "./SubtaskEditView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__